import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "inline", "badgeContent"];
import React from 'react';
import { intrinsicComponent } from '../../utils/functions';
import { BadgeColor } from './badge.props';
import Styled from './badge.styles';
var Badge = intrinsicComponent(function (_ref, ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? BadgeColor.Secondary : _ref$color,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    badgeContent = _ref.badgeContent,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Styled.BadgeRoot, {
    ref: ref
  }, /*#__PURE__*/React.createElement(Styled.Badge, _extends({
    color: color,
    inline: inline,
    badgeContent: badgeContent
  }, rest), badgeContent));
});
export default Badge;